import React from "react";
import Link from "next/link";

import type { RelatedBreedsProps } from "./relatedBreeds.types";

import s from "./relatedBreeds.module.scss";

const RelatedBreeds = ({ relatedBreeds }: RelatedBreedsProps) => {
  return (
    <div className={s.wrapper}>
      <h2 className="heading-sm">Raças relacionadas</h2>
      <div className={s.grid_images}>
        {relatedBreeds.map((breed, key) => (
          <Link
            href={`/racas/${breed.specie}/${breed.slug}`}
            key={key}
            className={s.link_image}
          >
            {breed.image && (
              <img src={breed.image.url} alt={breed.name} className={s.image} />
            )}
            <span className="subtitle-sm">{breed.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedBreeds;
